export default __webpack_public_path__ + "static/media/13 1.2ce64423.svg";